import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_BUYERS_SIDE_TOUR_REQUEST_GET_BY_LISTING_ID } from 'api/actionTypes';

export default async function getByListingId({ state, apiClient }, { listingId }) {
  typeCheck('listingId::PositiveNumber', listingId);

  await apiClient.postWithState({
    action: SR_API_ACTION_BUYERS_SIDE_TOUR_REQUEST_GET_BY_LISTING_ID,
    state: state,
    payload: {
      listingId,
    },
    onSuccess: (buyersSideTourRequest) => {
      if (buyersSideTourRequest) {
        state.set(['buyersSideTourRequests', 'byListingAndUserId'], {
          [`${buyersSideTourRequest.listingId}-${buyersSideTourRequest.userId}`]: buyersSideTourRequest,
        });
      }
    },
  });
}
